import { Stack } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { PdfSectionHeader } from "../components/PdfSectionHeader";
import { PdfTrafficSourcesList } from "../components/PdfTrafficSourcesList";

import { ShareOfWebsiteTrafficTable } from "./components/share-of-website-traffic-table/ShareOfWebsiteTrafficTable";

export const ShareOfWebsiteTrafficPdf = () => {
    const translate = useTranslation();

    return (
        <Stack
            gap="24px"
            margin="0 0 24px 0"
        >
            <PdfSectionHeader
                subtitle={translate("bt.report.channels.share-of-website-traffic-table.subtitle")}
                title={translate("bt.report.channels.share-of-website-traffic-table.title")}
            />
            <PdfTrafficSourcesList
                automationIds={{
                    title: "share-of-website-traffic-pdf-title",
                    body: "share-of-website-traffic-pdf-body",
                }}
            >
                {(trafficSource) => <ShareOfWebsiteTrafficTable trafficSource={trafficSource} />}
            </PdfTrafficSourcesList>
        </Stack>
    );
};
